import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'moduleVersionNumber',
})
export class ModuleVersionNumberPipe implements PipeTransform {
    transform(versionNumber: number) {
        return versionNumber === 0 ? 'Draft' : 'Version ' + versionNumber;
    }
}
